/**
 * The explore header is intentionally visible before sign-in in the isolated
 * Preview build. Its avatar must still be an honest account entry point: an
 * anonymous tap asks the person to sign in instead of briefly exposing a
 * private-looking profile and then bouncing them back to discovery.
 */
export function getExploreAvatarRoute(isAuthenticated: boolean): '/profile' | '/(auth)/login' {
  return isAuthenticated ? '/profile' : '/(auth)/login'
}
